<template>
  <FiltrosComponent
    :isCoordenador="isCoordenador"
    :nomeTela="'tarefa'"
    @aplicarFiltros="onAplicarFiltros"
  />

  <Carregamento v-if="carregando" />

  <div class="container">
    <div
      class="tarefa"
      v-for="tarefa in tarefasMarcadas"
      v-if="!abrirTarefa && !carregando"
      :key="tarefa.id"
    >
      <div class="card">
        <!-- Status na vertical como no primeiro código -->
        <div class="situacao-main">
          <h6
            class="situacao"
            :class="{
              'para-fazer': tarefa.estadoDescricao === 'PARA_FAZER',
              'em-andamento': tarefa.estadoDescricao === 'EM_ANDAMENTO',
              concluida: tarefa.estadoDescricao === 'CONCLUIDA',
              cancelada: tarefa.estadoDescricao === 'CANCELADA',
              'em-edicao': tarefa.estadoDescricao === 'EM_EDICAO',
            }"
          >
            {{ formatarEnum(tarefa.estadoDescricao) }}
          </h6>
        </div>

        <div
          class="card-body"
          @click.prevent="((abrirTarefa = true), (tarefaSelecionada = tarefa))"
        >
          <div class="card-head">
            <h5>{{ tarefa.titulo.toUpperCase() }}</h5>
          </div>

          <div class="descricao">
            <p class="card-text">
              Descrição: {{ limitarTexto(tarefa.descricao, 115) }}
            </p>
          </div>

          <div class="infos">
            <p class="card-text">Status: {{ tarefa.statusDescricao }}</p>
            <p class="card-text">
              Tempo Estimado: {{ minutosParaHoras(tarefa.tempoEstimado) }}
            </p>
          </div>
        </div>

        <div class="botoes">
          <button
            class="btn btn-primary editar"
            @click="edicaoTarefa(tarefa)"
            v-if="tarefa.isCoordenadorTarefa"
          >
            Editar
          </button>
        </div>
      </div>
    </div>
  </div>

  <RouterView />
  <FormCadastroTarefa
    v-if="route.query.modal === 'cadastrar-tarefa'"
    :acaoId="props.acaoId"
  />

  <FormEditarTarefa
    v-if="route.query.modal === 'editar-tarefa'"
    :tarefa="tarefaSelecionada"
    :acaoId="props.acaoId"
  />

  <PaginacaoComponent
    v-if="props.acaoId"
    :total-paginas="totalPaginas"
    @mudar-pagina="carregarPagina"
  />
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import FormEditarTarefa from "@/components/tarefas/FormEditarTarefa.vue";
import { formatarEnum } from "@/utils/FormatarEntradas";
import tarefaService from "@/service/tarefaService";
import PaginacaoComponent from "@/components/common/paginacaoComponent.vue";
import acaoService from "@/service/acaoService";
import userIn from "@/utils/userInfos";
import router from "@/router";
import { useRoute } from "vue-router";
import FormCadastroTarefa from "./FormCadastroTarefa.vue";
import FiltrosComponent from "@/components/common/FiltrosComponent.vue";
import Carregamento from "@/components/common/Carregamento.vue";

const emit = defineEmits(["abrir-tarefa"]);
const props = defineProps({
  acaoId: {
    type: String,
    required: true,
  },
  isCoordenador: {
    type: Boolean,
    required: true,
  },
});

const abrirTarefa = ref(false);
const tarefaSelecionada = ref({});
const editarTarefa = ref(false);
const tarefas = ref([]);
const ListaTarefasAtividades = ref([]);
const carregando = ref(false);
const paginaAtual = ref(0);
const totalPaginas = ref(1);
const user = userIn.getUserInfos();
const isCoordenador = ref();
const tarefasMarcadas = ref([]);
const usersTarefa = ref("");
const isLider = ref(false);
const route = useRoute();

function limitarTexto(texto, limite) {
  if (!texto) return "";
  if (texto.length <= limite) return texto;
  return texto.substring(0, limite) + "...";
}

const filtroGeralTarefas = ref({
  filtroPrincipal: "TAREFAS_GERAIS",
  filtroStatus: "EM_ANDAMENTO",
});

const filtrosTarefas = ref({
  filtroPrincipal: [
    { value: "TAREFAS_GERAIS", descricao: "Tarefas gerais" },
    {
      value: "TAREFAS_RELACIONADAS_A_ATIVIDADES",
      descricao: "Tarefas relacionadas a atividades",
    },
    { value: "MINHAS_TAREFAS", descricao: "Minhas tarefas" },
  ],
  filtroStatus: [
    { value: "EM_ANDAMENTO", descricao: "Tarefas em execução" },
    { value: "CONCLUIDA", descricao: "Tarefas concluídas" },
    { value: "CANCELADA", descricao: "Tarefas canceladas" },
  ],
});

async function adicionarFiltros() {
  const response = await tarefaService.getFiltroTarefas(
    props.acaoId,
    filtroGeralTarefas.value.filtroPrincipal,
    filtroGeralTarefas.value.filtroStatus,
    0,
    1000
  );

  const tarefasComAtividade = tarefasMarcadas.value.filter(
    (tarefa) => tarefa.atividadeId
  );
  const tarefasComUsuarios = tarefasMarcadas.value.filter(
    (tarefa) => tarefa.usuariosNomes
  );
  const user = userIn.getUserInfos();
  const userId = user?.userId;
  if (filtroGeralTarefas.value.filtroPrincipal === "TAREFAS_GERAIS") {
  }
  if (
    filtroGeralTarefas.value.filtroPrincipal ===
    "TAREFAS_RELACIONADAS_A_ATIVIDADES"
  ) {
    tarefasMarcadas.value = response;
  }
}

function onAplicarFiltros(filtros) {
  //implementar no futuro próximo
}

function abrirModal(modal) {
  router.push({
    query: {
      modal: modal,
    },
  });
}

function edicaoTarefa(tarefa) {
  editarTarefa.value = true;
  tarefaSelecionada.value = tarefa;

  abrirModal("editar-tarefa");
}

async function isCoordenadorAcao() {
  const membros = await acaoService.getMembrosTime(props.acaoId);

  // Verifica se o usuário logado é coordenador desta ação
  isCoordenador.value = membros?.some(
    (membro) =>
      membro.nome === user.nome && membro.funcaoMembro === "COORDENADOR"
  );

  // Garante que tarefas.value é um array
  const listaTarefas = Array.isArray(tarefas.value) ? tarefas.value : [];

  tarefasMarcadas.value = listaTarefas.reduce((acc, t) => {
    if (isCoordenador.value) {
      // Coordenador pode ver todas as tarefas da ação
      acc.push({
        ...t,
        isCoordenadorTarefa: true,
      });
    } else {
      // NÃO coordenador
      isLider.value = userIn.verificarLiderancaAtividade(t.atividadeId);

      if (isLider.value === true) {
        // Líder vê todas as tarefas, inclusive EM_EDICAO
        acc.push({
          ...t,
          isLider: true,
          isCoordenadorTarefa: false,
        });
      } else {
        // Não-líder: só vê tarefas que não estão EM_EDICAO
        if (t.estadoDescricao !== "EM_EDICAO") {
          acc.push({
            ...t,
            isLider: false,
            isCoordenadorTarefa: false,
          });
        }
        // Pode ver tarefas PARA_FAZER sem atividade se for membro da tarefa
        if (t.estadoDescricao === "PARA_FAZER" && t.atividadeNome === null) {
          const pertenceAoUsuario = t.usuariosNomes?.some(
            (usuarioTarefa) => usuarioTarefa.nome === user.nome
          );
          if (pertenceAoUsuario) {
            acc.push({
              ...t,
              isLider: false,
              isCoordenadorTarefa: false,
            });
          }
        }
      }
    }

    return acc;
  }, []);
}

function limparFiltros() {}

function minutosParaHoras(minutos) {
  const horas = Math.floor(minutos / 60);
  const minutosRestantes = minutos % 60;
  return `${horas}h ${minutosRestantes}m`;
}

function carregarPagina(pagina) {
  router.push({
    query: {
      page: pagina,
    },
  });
}

async function carregarTarefas(pagina) {
  carregando.value = true;

  try {
    const { tarefa, totalPages } = await tarefaService.getTarefasByAcao(
      pagina,
      20,
      props.acaoId,
      true
    );

    tarefas.value = tarefa;
    totalPaginas.value = totalPages;

    isCoordenadorAcao();
  } catch (error) {
    console.error(error);
  } finally {
    carregando.value = false;
  }
}

watch(tarefasMarcadas.value, async (newVal, oldVal) => {
  if (newVal.length === 0 && paginaAtual.value < 6) {
    paginaAtual.value++;
    await carregarTarefas(paginaAtual.value);
  } else if (newVal.length === 0 && paginaAtual.value > 0) {
    paginaAtual.value--;
    await carregarTarefas(paginaAtual.value);
  }
});

watch(abrirTarefa, (novoValor) => {
  if (novoValor) {
    abrirTarefa.value = false;

    router.push({
      name: "acao-tarefas-view",
      params: { tarefaId: tarefaSelecionada.value.id },
    });
  }
});

watch(
  () => route.query.page,
  (pagina) => {
    carregarTarefas(Number(pagina ?? 0));
  },
  {
    immediate: true,
  }
);

onMounted(() => {
  if (route.query.page == null) {
    carregarPagina(0);
  }
});
</script>

<style scoped>
.container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.8rem;
  padding: 1rem;
  align-items: start;
}

/* Forçar 3 colunas em telas grandes */
@media (min-width: 1200px) {
  .container {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* ---- TAREFA ---- */
.container .tarefa {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 224px;
  position: relative;
  margin: 0;
  padding: 0;
  align-items: flex-start;
  justify-content: space-between;
  max-width: 100%;
}

/* ---- CARD ---- */
.container .tarefa .card {
  position: relative;
  background-color: var(--cinza);
  height: 224px;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: flex-start;
  margin: 0;
  border: none;
  max-width: 100%;
  overflow: hidden;
  text-align: left;
  transition: all 0.2s;
  gap: 10px;
}

.container .tarefa .card:hover {
  transform: scale(1.04);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}
.situacao-main {
  position: relative;
  width: 50px;
  height: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.situacao {
  color: #ffffff;
  margin: 0;
  padding: 10px 5px;
  width: 100%;
  height: 100%;
  writing-mode: vertical-lr;
  text-orientation: mixed;
  transform: rotate(180deg);
  font-size: 1rem;
  font-weight: 600;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
}

/* Classes para os estados das tarefas */
.para-fazer {
  background-color: var(--azul-escuro);
}

.em-edicao {
  background-color: var(--roxo-claro);
}
.cancelada {
  background-color: var(--vermelho);
}
.concluida {
  background-color: var(--verde);
}
.em-andamento {
  background-color: var(--laranja);
}
/* ---- CARD BODY ---- */
.card-body {
  padding: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  flex: 1;
  gap: 7px;
  margin-top: 7px;
  cursor: pointer;
}

.card-head {
  width: 100%;
}

.card-head h5 {
  text-align: left;
  font-size: 1.1rem;
  color: var(--preto);
  font-weight: 600;
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

.descricao {
  width: 100%;
}

.descricao .card-text {
  width: 100%;
  margin: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  text-align: left;
}

.infos {
  width: 100%;
  padding: 0;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.infos .card-text {
  margin: 0;
  font-weight: 600;
}

/* ---- BOTÕES ---- */
.botoes {
  position: absolute;
  bottom: 10px;
  right: 10px;
}

.btn {
  background: var(--roxo-claro);
  color: var(--branco);
  font-size: 0.85rem;
  font-weight: 600;
  padding: 5px 20px;
  border-radius: 3px;
  transition: 0.25s ease;
  border: none;
}

.btn:hover {
  background: var(--roxo-escuro);
}
@media (max-width: 1199px) {
  .container {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
}

@media (max-width: 768px) {
  .container {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  }

  .situacao {
    font-size: 0.8rem;
    padding: 0.5rem 1rem;
  }

  .card-body {
    padding: 0.5rem;
  }

  .card-head h5 {
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .container {
    grid-template-columns: 1fr;
  }

  .container .tarefa {
    height: 224px;
  }

  .container .tarefa .card {
    height: 224px;
  }

  .btn {
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
  }
}

/* Mantém os filtros como estão */
.card-filtros {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  justify-content: space-between;
  width: auto;
  border-bottom: 2px solid var(--preto);
  margin-bottom: 3%;
}

/* btn paginação */
.btn-paginacao {
  background-color: var(--roxo-escuro);
}
.btn-filtro {
  background-color: var(--branco);
  color: var(--roxo-escuro);
  padding: 5px;
  border-radius: 10px;
  border: var(--roxo-escuro) 2px groove;
  font-size: 15px;
  margin-left: 5%;
}

.btn-filtro:hover {
  background-color: rgb(54, 32, 101);
  color: white;
  transition: 500ms;
}

.btnn {
  background-color: var(--branco);
  color: var(--roxo-escuro);
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 15px;
  border: var(--roxo-escuro) 2px groove;
}

.filtros {
  width: 80%;
  margin-right: 2%;
  margin-bottom: 2%;
  display: flex;
  flex-direction: column;
}

.naoCoordenador {
  width: 100%;
}

.filtrosmain {
  display: flex;
  gap: 20px;
}

.btn-group {
  display: flex;
  gap: 20px;
}

.dropdown-menu button {
  width: 100%;
  border: none;
  border-bottom: 2px solid black;
}

@media (max-width: 891px) {
  .filtrosmain {
    flex-direction: column;
  }
  .card-filtros {
    align-items: flex-end;
  }
}

@media (max-width: 534px) {
  .btn-group {
    flex-direction: column;
  }
  .card-filtros {
    flex-direction: column-reverse;
    align-items: center;
  }
}
</style>
